import { IconContent } from '@icons';

export const chat: IconContent = {
    sm: '<path d="M4 13.5h1.651l.126-.084L8.651 11.5H14v-9H2v9h2v2Zm1-1v-2H3v-7h10v7H8.349l-.126.084L5.349 12.5H5ZM11.5 6h-7V5h7v1Zm-7 2h5V7h-5v1Z" />',
};
